import { TFunction } from 'next-i18next';

export const getCustomerGroupMessage = (t: TFunction, groupId: number) => {
  const employeeGroupId = Number(
    process.env.NEXT_PUBLIC_BIGCOMMERCE_EMPLOYEE_GROUP_ID
  );
  const memberGroupId = Number(
    process.env.NEXT_PUBLIC_BIGCOMMERCE_MEMBER_GROUP_ID
  );
  const caffrGroupId = Number(
    process.env.NEXT_PUBLIC_BIGCOMMERCE_CAFFR_GROUP_ID
  );
  const acmgGroupId = Number(process.env.NEXT_PUBLIC_BIGCOMMERCE_ACMG_GROUP_ID);
  const familyGroupId = Number(
    process.env.NEXT_PUBLIC_BIGCOMMERCE_FAMILY_GROUP_ID
  );
  const honoraryGroupId = Number(
    process.env.NEXT_PUBLIC_BIGCOMMERCE_HONORARY_GROUP_ID
  );
  const ambassadorGroupId = Number(
    process.env.NEXT_PUBLIC_BIGCOMMERCE_AMBASSADORS_GROUP_ID
  );
  const employee20YearGroupId = Number(
    process.env.NEXT_PUBLIC_BIGCOMMERCE_EMPLOYEE_20YEAR_GROUP_ID
  );

  switch (groupId) {
    case employeeGroupId:
      return t('common:cart.mec.staff');
    case memberGroupId:
      return t('common:cart.member.price');
    case caffrGroupId:
    case acmgGroupId:
      return t('common:cart.industry.partner');
    case familyGroupId:
      return t('common:cart.family.price');
    case honoraryGroupId:
      return t('common:cart.honorary.price');
    case employee20YearGroupId:
      return t('common:cart.mec.20year');
    case ambassadorGroupId:
      return t('common:cart.mec.ambassador');
    default:
      return '';
  }
};
